<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton @click.native="openDialog" color="primary">
        <v-img
          src="@/assets/svg/send_offer_message.svg"
          class="offer-action-icon"
          size="50"
        />
        <span :class="{ 'ml-1': isMobile }"> Submit for Approval </span>
      </SecondaryButton>
      <SubmitForApprovalDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import SubmitForApprovalDialog from "@/views/offers/dialogs/SubmitForApprovalDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "SubmitForApprovalAction",
  components: {
    SecondaryButton,
    SubmitForApprovalDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
